export const checkLanguage = () => {
  const language = navigator.language || navigator.userLanguage;
  if (language.includes("es")) {
    return "es-ES"
  } else {
    return "en-Gb"
  }
}